import { FuelAccordionContainer, FuelAccordionItem, FuelRadio } from '@frete.com/fuel-react';
import React, { FC, RefObject, useEffect, useRef } from 'react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { dsTheme } from 'constants/styled.contants';
import { SortFilter, TSortList, VALUES } from './types';

const Sort: FC<SortFilter> = ({ checked, setChecked }) => {
  const radioRef = useRef<React.RefObject<HTMLFuelRadioElement>[]>(VALUES.map(() => React.createRef()));

  const handleChecked = (e: CustomEvent<HTMLFuelRadioElement>) => {
    const element = e.currentTarget as HTMLInputElement;
    setChecked(element.value);
  };

  useEffect(() => {
    /* istanbul ignore else */
    if (radioRef.current.length === VALUES.length) {
      radioRef.current.forEach((item: RefObject<HTMLFuelRadioElement>) => {
        item?.current?.addEventListener('fuel-change', handleChecked);
      });
    }

    return () =>
      radioRef.current &&
      radioRef.current.forEach((item: RefObject<HTMLFuelRadioElement>) => {
        item?.current?.removeEventListener('fuel-change', handleChecked);
      });
  }, [radioRef]);

  return (
    <FuelAccordionContainer>
      <FuelAccordionItem
        data-testid="accordion-item-sort"
        key="Ordenar por"
        label="Ordenar por"
        accordionId="Ordenar por"
        hasDivider
      >
        <FuelFlex
          defaultProps={{
            flexDirection: 'column',
            alignItems: 'stretch',
            width: '100%',
            customPadding: `0 ${dsTheme.spacing.km1} ${dsTheme.spacing.km4} ${dsTheme.spacing.km1}`,
          }}
          slot="content"
        >
          {VALUES.map((item: TSortList, i) => (
            <FuelRadio
              label={item.label}
              key={item.value}
              name="sort"
              value={item.value}
              data-testid={`radio-input-${item.value}`}
              ref={radioRef.current[i]}
              checked={checked === item.value}
            />
          ))}
        </FuelFlex>
      </FuelAccordionItem>
    </FuelAccordionContainer>
  );
};

export default Sort;
